import { Col } from 'antd'
import dayjs from 'dayjs'

import {
  EpidemiologyCaseForm058E_SymptomsSection,
  PatientVaccinatedStatus
} from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}
export const VaccineSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const status =
    symptoms.vaccinePreventableInfections?.patientVaccinated?.status

  const numberOfDosesLabel = t('epidemiology.symptoms.vaccine.numberOfDoses')
  const lastDoseDateLabel = t('epidemiology.symptoms.vaccine.lastDoseDate')

  return (
    <>
      <Col span={24}>
        <Text>
          {`11. ${t('epidemiology.symptoms.vaccine.patientVaccinated')}`}:{' '}
          <Text weight={400}>
            {t(`epidemiology.symptoms.general.${status}`)}
          </Text>
        </Text>
      </Col>

      {status === PatientVaccinatedStatus.YES_ACCORDING_TO_SCHEDULE && (
        <>
          {symptoms.vaccinePreventableInfections?.patientVaccinated
            ?.yesAccordingToSchedule?.numberOfDoses?.value && (
            <Col span={12}>
              <Text>
                {numberOfDosesLabel}:{' '}
                <Text weight={400}>
                  {
                    symptoms.vaccinePreventableInfections?.patientVaccinated
                      ?.yesAccordingToSchedule?.numberOfDoses?.value
                  }{' '}
                </Text>
              </Text>
            </Col>
          )}

          {symptoms.vaccinePreventableInfections?.patientVaccinated
            ?.yesAccordingToSchedule?.lastDoseDate?.value && (
            <Col span={12}>
              <Text>
                {lastDoseDateLabel}:{' '}
                <Text weight={400}>
                  {dayjs(
                    symptoms.vaccinePreventableInfections?.patientVaccinated
                      ?.yesAccordingToSchedule?.lastDoseDate?.value
                  ).format(dayMonthYearFormatWithDot)}
                </Text>
              </Text>
            </Col>
          )}
        </>
      )}

      {status === PatientVaccinatedStatus.YES_WITH_VIOLATIONS && (
        <>
          {symptoms.vaccinePreventableInfections?.patientVaccinated
            ?.yesWithViolations?.numberOfDoses?.value && (
            <Col span={12}>
              <Text>
                {numberOfDosesLabel}:{' '}
                <Text weight={400}>
                  {
                    symptoms.vaccinePreventableInfections?.patientVaccinated
                      ?.yesWithViolations?.numberOfDoses?.value
                  }
                </Text>
              </Text>
            </Col>
          )}

          {symptoms.vaccinePreventableInfections?.patientVaccinated
            ?.yesWithViolations?.lastDoseDate?.value && (
            <Col span={12}>
              <Text>
                {lastDoseDateLabel}:{' '}
                <Text weight={400}>
                  {dayjs(
                    symptoms.vaccinePreventableInfections?.patientVaccinated
                      ?.yesWithViolations?.lastDoseDate?.value
                  ).format(dayMonthYearFormatWithDot)}
                </Text>
              </Text>
            </Col>
          )}
        </>
      )}
    </>
  )
}
